<template>
    <v-dialog persistent no-click-animation v-model="show" width="450">
        <div class="QCBatchPermissionEditor">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('assignee') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="px-10 py-10">
                <v-form ref="form" v-model="formValid" @submit="submit">
                    <div class="display-flex align-center">
                        <v-autocomplete
                            v-model="newAssignee"
                            :items="listUsers"
                            item-text="email"
                            item-value="email"
                            class="input-custom"
                        ></v-autocomplete>
                        <div class="btn-primary ml-10" @click="addAssignee">{{ $f.tc('add') }}</div>
                    </div>
                </v-form>
                <div class="label mt-12">
                    {{ $f.tc('assigneeList') }}
                </div>
                <table class="table-assignees">
                    <tbody>
                    <tr v-for="(assignee, index) in assigneeList" :key="assignee">
                        <td>{{ assignee }}</td>
                        <td>
                            <v-btn icon small @click="deleteAssignee(index)">
                                <img src="/img/delete-member.svg" alt="icon-delete">
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-primary mr-8" @click="submit">{{ $f.tc('save') }}</div>
                <div class="btn-outline-secondary" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormRules from "@/modules/fptai/utils/FormRules";
import {AppServiceEventBus, AppServiceEventBusType} from "@/eventbus/appservice.eventbus";
import QcCampaignService from "@/services/qc.campaign.service";

const defaultRules = [FormRules.ruleRequired]

export default {
    name: 'QCBatchPermissionEditor',
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            newAssignee: '',
            options: [],
            assigneeList: []
        }
    },
    computed: {
        listUsers () {
            return this.options.filter(i => !this.assigneeList.includes(i.email))
        }
    },
    methods: {
        open(list, options) {
            this.assigneeList = list ? list : []
            this.options = options ? options : []
            this.$refs.form.resetValidation()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        submitValidForm() {
            this.close()
            this.promise.resolve(this.assigneeList)
        },
        cancel() {
            this.show = false
            this.promise.reject(false)
        },
        addAssignee () {
            if (this.newAssignee) {
                this.assigneeList.push(this.newAssignee)
                this.newAssignee = ""
                this.$refs.form.resetValidation()
            } else {
                this.$appService.toastError(this.$f.tc('pleaseEnterAllFields'))
            }
        },
        deleteAssignee (index) {
            if (index > -1) {
                this.assigneeList.splice(index, 1)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.QCBatchPermissionEditor {
    background: #FFFFFF;
    border-radius: 0 !important;
    overflow: hidden;

    .dialog-header {
        border-bottom: 1px solid #DADFEC;
    }

    .dialog-content {
        padding: 12px;
        max-height: 500px;
        overflow-y: auto;
    }

    .dialog-footer {
        justify-content: center;
        padding: 10px;
        border-top: 1px solid #DADFEC;
    }
}

table.table-assignees {
    border-collapse: collapse;
    width: 100%;
    font-size: 14px;

    tr {
        td {
            border: 1px solid #DADFEC;
            height: 40px !important;
            padding: 0 10px;
        }

        td:last-child {
            width: 67px;
            text-align: center;
        }
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            padding: 6px 10px 6px 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 36px !important;
        top: 11px !important;
    }

    .v-input input {
        height: 36px;
    }
}
</style>
